(function () {
  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function productHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function strings() {
    var vs = window.variantStrings || {};
    return {
      addToCart: vs.addToCart || 'In den Warenkorb',
      soldOut: vs.soldOut || 'Ausverkauft',
    };
  }

  function setButtonState(wrap, available, labels) {
    var cartAdd = wrap.querySelector('xo-cart-add');
    var button = wrap.querySelector('.xo-btn');
    var textEl = wrap.querySelector('.xo-btn__text');
    if (!button || !textEl) return;

    if (available) {
      wrap.removeAttribute('xo-disabled');
      if (cartAdd) {
        cartAdd.removeAttribute('xo-disabled');
        cartAdd.removeAttribute('disabled');
      }
      button.disabled = false;
      textEl.textContent = labels.addToCart;
      textEl.setAttribute('data-text', labels.addToCart);
      return;
    }

    wrap.setAttribute('xo-disabled', '');
    if (cartAdd) cartAdd.setAttribute('xo-disabled', '');
    button.disabled = true;
    textEl.textContent = labels.soldOut;
    textEl.setAttribute('data-text', labels.soldOut);
  }

  async function syncProductAvailability() {
    var handle = productHandle();
    if (!handle) return;

    var wraps = document.querySelectorAll('.buy-button__add');
    if (!wraps.length) return;

    try {
      var response = await fetch(routesRoot() + 'products/' + handle + '.js', {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;

      var product = await response.json();
      var variant =
        product.variants.find(function (v) {
          return v.available;
        }) || product.variants[0];

      if (!variant) return;

      var labels = strings();
      wraps.forEach(function (wrap) {
        setButtonState(wrap, variant.available, labels);
      });

      document.querySelectorAll('xo-product').forEach(function (productEl) {
        if (variant.available) {
          productEl.removeAttribute('xo-disabled');
        } else {
          productEl.setAttribute('xo-disabled', '');
        }
      });
    } catch (error) {
      console.warn('[Mevlana availability]', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncProductAvailability);
  } else {
    syncProductAvailability();
  }
})();
